export const PROBLEM_TYPE_OPTIONS = [
  {
    value: '违反强制性条文',
    label: '违反强制性条文'
  }, {
    value: '违反强制性标准',
    label: '违反强制性标准'
  }, {
    value: '法律法规',
    label: '法律法规'
  },{
    value: '设计深度及其他',
    label: '设计深度及其他'
  }, {
    value: '绿建设计',
    label: '绿建设计'
  }
];
export const PROBLEM_STRONG_OPTIONS = [
  {
    value: '房屋建筑',
    label: '房屋建筑'
  }, {
    value: '市政技术设施工程',
    label: '市政技术设施工程'
  }, {
    value: '消防',
    label: '消防'
  },{
    value: '人防',
    label: '人防'
  },{
    value: '防雷',
    label: '防雷'
  },{
    value: '其他',
    label: '其他'
  }
  ];
export const PROBLEM_SUBMAJOR_OPTIONS = [
  {
    value: '勘察和地基基础',
    label: '勘察和地基基础'
  }, {
    value: '结构设计',
    label: '结构设计'
  }, {
    value: '抗震设计',
    label: '抗震设计'
  }, {
    value: '鉴定和加固',
    label: '鉴定和加固'
  }, {
    value: '绿建设计',
    label: '绿建设计'
  }, {
    value: '人防设计',
    label: '人防设计'
  }
];

export const DANGER_TYPE_OPTIONS = [
  {
    value: '一般',
    label: '一般'
  }, {
    value: '较严重',
    label: '较严重'
  }, {
    value: '严重',
    label: '严重'
  }
];

export const PROFESSIONALCON1 = [
  {
    value: '建筑专业',
    label: '建筑专业'
  }, {
    value: '勘察（岩土）专业',
    label: '勘察（岩土）专业'
  }
];

export const PROFESSIONALCON2 = [
  {
    value: '建筑专业',
    label: '建筑专业'
  }, {
    value: '结构专业',
    label: '结构专业'
  },{
    value: '给排水专业',
    label: '给排水专业'
  },{
    value: '暖通专业',
    label: '暖通专业'
  },{
    value: '电气专业',
    label: '电气专业'
  },{
    value: '其他',
    label: '结构其他专业'
  }
];

export const PROFESSIONALCON3 = [
  {
    value: '建筑专业',
    label: '建筑专业'
  }, {
    value: '结构专业',
    label: '结构专业'
  },{
    value: '道路桥隧',
    label: '道路桥隧'
  },{
    value: '市政给排水',
    label: '市政给排水'
  },{
    value: '燃气专业',
    label: '燃气专业'
  },{
    value: '热力专业',
    label: '热力专业'
  },{
    value: '风景园林',
    label: '风景园林'
  },{
    value: '环境卫生',
    label: '环境卫生'
  },{
    value: '公共交通',
    label: '公共交通'
  },{
    value: '线路专业',
    label: '线路专业'
  },{
    value: '弱点专业',
    label: '弱点专业'
  },{
    value: '强电专业',
    label: '强电专业'
  },{
    value: '装修专业',
    label: '装修专业'
  },{
    value: '通风空调系统（含节能）专业',
    label: '通风空调系统（含节能）专业'
  },{
    value: '动力照明（含节能）专业',
    label: '动力照明（含节能）专业',
  },{
    value: '给排水及消防专业',
    label: '给排水及消防专业',
  },{
    value: '其他',
    label: '其他',
  }
];
export const PROFESSIONALCON4 = [
  {
    value: '城市勘察',
    label: '城市勘察'
  }, {
    value: '地基处理',
    label: '地基处理'
  },{
    value: '地基勘察',
    label: '地基勘察'
  },{
    value: '基坑支护',
    label: '基坑支护'
  }
];
export const PROFESSIONALCON5 = [
  { 
    value: '房屋抗震设计',
    label: '房屋抗震设计'
  }, {
    value: '建筑防火',
    label: '建筑防火'
  },{
    value: '建筑节能',
    label: '建筑节能'
  },{
    value: '建筑设备',
    label: '建筑设备'
  },{
    value: '建筑设计',
    label: '建筑设计'
  },{
    value: '结构鉴定和加固',
    label: '结构鉴定和加固'
  },{
    value: '结构设计',
    label: '结构设计'
  },{
    value: '勘察和地基基础',
    label: '勘察和地基基础'
  }
];



// WEBPACK FOOTER //
// ./src/views/login/constants.js